import { queryString } from '@woovi/shared';

const { parse } = queryString;

type Params = {
  appID: string;
  correlationID: string;
  paymentLinkID: string;
  node: string;
  pluginType: string;
  isTemp: boolean;
  requestCustomer: boolean;
  requestPhone: boolean;
  requestEmail: boolean;
  requestAddress: boolean;
  redirectUrl: string;
};
export const getCurrentScriptParams = (): Partial<Params> => {
  try {
    const me = document.currentScript;

    if (!me) {
      return {};
    }

    const [, query] = me.src.split('?');

    if (!query) {
      return {};
    }

    return parse(query);
  } catch (err) {
    return {};
  }
};
